import { useState } from "react";
import "./Qualification.css";
import QualificationData from "./QualificationData";

export default function Qualification() {
  const [toggleState, setToggleState] = useState(1);

  const toggleTabWork = () => {
    setToggleState(1);
  };
  const toggleTabAcademy = () => {
    setToggleState(2);
  };
  const toggleTabVolunteer = () => {
    setToggleState(3);
  };

  return (
    <section className="qualification section" id="qualification">
      <h2 className="section__title">Experience</h2>
      <span className="section__subtitle">My timeline</span>

      <div className="qualification__container container">
        <div className="qualification__tabs">
          <div
            className={
              toggleState === 1
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex"
            }
            onClick={toggleTabWork}
          >
            <i className="uil uil-briefcase-alt qualification__icon"></i> Work
          </div>

          <div
            className={
              toggleState === 2
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex"
            }
            onClick={toggleTabAcademy}
          >
            <i className="uil uil-graduation-cap qualification__icon"></i>{" "}
            Academy
          </div>

          <div
            className={
              toggleState === 3
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex"
            }
            onClick={toggleTabVolunteer}
          >
            <i className="uil uil-users-alt qualification__icon"></i> Community
          </div>
        </div>

        <div className="qualification__sections hidden">
          <div
            className={
              toggleState === 1
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            <QualificationData
              role="Mobile Application Developer"
              company="Reev InfoTech Pvt. Ltd."
              dateSpan="Nov 2023 - Present"
            />
            <QualificationData
              role="Associate Software Engineer"
              company="Dohoro Management Pvt. Ltd."
              dateSpan="Feb 2025 - Present"
              right={true}
            />
            <QualificationData
              role="Software Engineer"
              company="Yarsa Enterprise Solution"
              dateSpan="Aug 2025 - Nov 2025"
            />
            <QualificationData
              role="Mobile Application Lead"
              company="DLPlatforms Pty Ltd"
              dateSpan="Aug 2024 - Feb 2025"
              right={true}
            />
            <QualificationData
              role="Freelancer"
              company="Home"
              dateSpan="Jan 2023 - Present"
            />
          </div>

          <div
            className={
              toggleState === 2
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            <QualificationData
              role="Mount Annapurna Campus"
              company="Bsc. CSIT"
              dateSpan="Apr 2022 - Present"
            />
            <QualificationData
              role="Junior Citizens' Academy"
              company="+2, Science"
              dateSpan="Jul 2019 - Aug 2021"
              right={true}
            />
            <QualificationData
              role="Siddivinayak Boarding School"
              company="SEE"
              dateSpan="Apr 2012 - Mar 2019"
            />
          </div>

          <div
            className={
              toggleState === 3
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            <QualificationData
              role="Executive Committee Member"
              company="MacIT Hub"
              dateSpan="March 2024 - Present"
            />
            <QualificationData
              role="Joint Treasurer"
              company="CSIT Association of Nepal - CSITAN Pokhara"
              dateSpan="Nov 2023 - Jun 2024"
              right={true}
            />
            <QualificationData
              role="Executive Committee Member"
              company="CSIT Association of Nepal - CSITAN Pokhara"
              dateSpan="Nov 2022 - Nov 2023"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
